"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var event_1 = require("./event");
var coll_base_1 = require("@ali/coll-base");
var coll_base_2 = require("@ali/coll-base");
var coll_type_1 = require("@ali/coll-base/lib/coll.type");
// import * as md5Base64 from 'md5-base64';
var Hashes = require("jshashes");
var md5Base64 = new Hashes.MD5().b64;
;
;
;
var CONST_ENV = {
    'dev': {
        url: '//linkdaily.tbsandbox.com/gateway/link.do',
        code: 'experience-data-monitor',
    },
    'prod': {
        // url: 'http://aplink.cloud.cainiao.com/gateway/link.do', // 新加坡
        url: '//shidclink.cainiao.com/gateway/link.do',
        // url: '//rulink.cainiao.com/gateway/link.do', // 俄罗斯
        code: 'experience-data-monitor',
    }
};
var Coll = /** @class */ (function () {
    function Coll() {
        this.link = CONST_ENV.prod;
        this.daily = false; // 默认非日常
        this.collType = 'ware';
        this.cookies = {};
        this.rest = {}; // setConfig业务字段
        this.version = '1.1.24';
    }
    // 暂不兼容老的IE
    Coll.prototype.getXhr = function () {
        return (new XMLHttpRequest());
    };
    // data 是最红的日志数据
    Coll.prototype.post = function (data, category, locale) {
        var _this = this;
        var xhr = this.getXhr();
        var url = this.link.url;
        if (locale && coll_type_1.CONST_AREA_URL[locale]) {
            url = coll_type_1.CONST_AREA_URL[locale];
        }
        xhr.open("post", url, true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;");
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                if (_this.daily) {
                    console.log("[debug] " + xhr.responseText);
                }
            }
        };
        var subSource = coll_type_1.CONST_SUB_SOURCE[category];
        var providerId = coll_type_1.CONST_PROVIDER_ID[category];
        var lengStr = JSON.stringify({
            _source: this.link.code,
            _subSource: subSource,
            opTime: new Date().getTime(),
            msg: data.length && data.map ? data : [data]
        });
        var signData = "" + lengStr + providerId;
        var sign = md5Base64(signData);
        // 日常线上是一个配置
        var reqPara = {
            msg_id: '',
            msg_type: 'PRISMLINK',
            logistic_provider_id: providerId,
            to_code: providerId,
            data_digest: sign.replace(/\+/g, '%2B'),
            logistics_interface: lengStr
        };
        var retStr = [];
        for (var k in reqPara) {
            retStr.push(k + "=" + reqPara[k]);
        }
        xhr.send(retStr.join('&'));
    };
    /*
     * @input : category: 上报的接口类型，背后对应一个数据结构
     * @input : data: 上报的内容
     * @input : locale 地区设置，cn 上海， sg 新加坡， ru 俄罗斯
     * @output : bool: 是否发送上报
    */
    Coll.prototype.log = function (category, data, locale) {
        var _this = this;
        // 增加支持 list 的批量上报
        if (!(data.length && typeof data.map === 'function')) {
            data = [data];
        }
        var logObjList = data.map(function (item) {
            var info = coll_base_1.extend({
                bizType: _this.bizType,
                spm: _this.spm,
                deviceType: 'pc',
                ns_a: _this.ns_a,
                ns_b: _this.ns_b,
                ns_c: _this.ns_c,
                ns_d: _this.ns_d,
                deviceId: _this.deviceId,
                userId: _this.userId,
                whId: _this.whId,
            }, item);
            var logObj;
            switch (category) {
                case 'jserror':
                    logObj = coll_base_1.getJsError(info);
                    break;
                case 'api':
                    logObj = coll_base_1.getApi(info);
                    break;
                case 'per': // per请求只会发送一次， 这里需要暂存，配置基本参数后发送
                    logObj = coll_base_1.getPer(info);
                    logObj.uid = _this.getUid();
                    if (Object.keys(_this.rest).length > 0) {
                        logObj = coll_base_1.extend({}, _this.rest, logObj);
                    }
                    break;
                case 'log':
                    logObj = coll_base_1.getLog(info);
                case 'jsonp':
                    logObj = info;
                    break;
                default:
                    logObj = info;
            }
            return coll_base_2.reduceObj(category, logObj, _this.collType);
        });
        // Link约定的是上传一个数组，支持合并上报
        if (coll_type_1.CONST_SUB_SOURCE[category]) {
            this.post(logObjList, category, locale);
            return true;
        }
        return false;
    };
    Coll.prototype.setConfig = function (config) {
        var ns_a = config.ns_a, ns_b = config.ns_b, ns_c = config.ns_c, ns_d = config.ns_d, deviceId = config.deviceId, userId = config.userId, whId = config.whId, bizType = config.bizType, daily = config.daily, spm = config.spm, collType = config.collType, bindError = config.bindError, rest = __rest(config, ["ns_a", "ns_b", "ns_c", "ns_d", "deviceId", "userId", "whId", "bizType", "daily", "spm", "collType", "bindError"]);
        this.ns_a = ns_a || this.ns_a;
        this.ns_b = ns_b || this.ns_b;
        this.ns_c = ns_c || this.ns_c;
        this.ns_d = ns_d || this.ns_d;
        this.deviceId = deviceId || this.deviceId;
        this.userId = userId || this.userId;
        this.whId = whId || this.whId;
        if (config.bizType) {
            this.bizType = bizType;
        }
        if (config.daily) {
            this.daily = daily;
        }
        if (config.spm) {
            this.spm = spm;
        }
        if (config.collType) {
            this.collType = collType;
        }
        if (this.daily) {
            this.link = CONST_ENV.dev;
        }
        else {
            this.link = CONST_ENV.prod;
        }
        if (Object.keys(rest).length > 0) {
            this.rest = rest;
        }
        this.link.url = coll_type_1.CONST_AREA_URL[event_1.default.getArea()];
        if (this.__cache_) {
            if (this.__cache_.length && this.__cache_.map) {
                this.__cache_ = this.__cache_.map(function (item) {
                    return coll_base_1.extend(item, rest);
                });
            }
            else {
                this.__cache_ = coll_base_1.extend(this.__cache_, rest);
            }
            var success = this.log('per', this.__cache_);
            if (success) {
                this.__cache_ = null;
            }
        }
        if (!bindError) {
            this.bind();
        }
    };
    /**
     * 事件绑定
     *
     * @return {void}
     */
    Coll.prototype.bind = function () {
        // 页面已绑定的onerror事件
        var win = window;
        var onErrorHandler = win.onerror;
        var collType = this.collType;
        var __log = this.log.bind(this);
        // unload
        // event.on(win, 'beforeunload', function () {
        //     wpo.clear();
        //     if (wpo.speed.points) {
        //         wpo.speed(null, null, true);
        //     }
        // }, true);
        // error处理
        win.onerror = function (msg, file, line, col, error) {
            if (onErrorHandler) {
                onErrorHandler(msg, file, line, col, error);
            }
            var category = 'jserror';
            var errInfo = coll_base_2.msgEventToJsError(msg, file, line, col, error);
            var logObj = coll_base_2.reduceObj(category, errInfo, collType);
            __log(category, logObj);
        };
    };
    Coll.prototype.getCookie = function (name) {
        var reg, matches, cookie = '';
        if (!this.cookies[name]) {
            reg = new RegExp(name + '=([^;]+)');
            try {
                cookie = document.cookie;
            }
            catch (e) {
            }
            matches = reg.exec(cookie);
            if (matches) {
                this.cookies[name] = matches[1];
            }
        }
        return this.cookies[name];
    };
    Coll.prototype.getUid = function () {
        var nick = '';
        try {
            // 分别取菜鸟会员、集团UID
            nick = this.getCookie('accountId') || this.getCookie('cna') || this.getCookie('lgc') || '';
        }
        catch (e) {
        }
        return nick;
    };
    return Coll;
}());
exports.Coll = Coll;
//# sourceMappingURL=core.js.map